import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/activeClientsSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const ProspectTypes = () => {
  const dispatch = useDispatch();
  const options = useSelector((state) => state.activeClients.filters.prospect_types);
  const selectedOption = useSelector((state) => state.activeClients.selectedFilters.prospect_types);

  return (
    <div className="select-box-no-width" style={{ width: "140px" }}>
      <p>Prospect Types</p>
      <MultiSelectDropdown
        options={options}
        selectedFilters={selectedOption}
        height="350px"
        numberDisplayed={0}
        enableOnly
        includeSelectAll
        onSelectChange={(newValue) => dispatch(actionCreators.updateProspectType(newValue))}
      />
    </div>
  );
};

export default ProspectTypes;
